import React from 'react'
import { DownloadArrowSVG } from 'src/components/Icons/Basic'
import { PERMISSIONS } from 'src/config/roleConfig'
import { useHasRequiredPermissions } from 'src/app/AppAuth/AppAuth.hooks'
import { Tooltip, TooltipPositions } from '../Tooltip/Tooltip'
import { IconButton, IconButtonVariant } from './IconButton'

export interface ExportIconButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  isDisabled?: boolean
  tooltipText?: string
  requiredPermissions?: PERMISSIONS[]
  id?: string
  testId?: string
}

export const ExportIconButton = ({
  onClick,
  isDisabled = false,
  tooltipText = 'Export',
  requiredPermissions = [PERMISSIONS.READ],
  id = 'export-button',
  testId,
}: ExportIconButtonProps): JSX.Element => {
  const hasPermission = useHasRequiredPermissions(requiredPermissions)
  const isButtonDisabled = isDisabled || !hasPermission
  const generatedTooltipId = React.useId()
  const tooltipId = id ?? generatedTooltipId

  const tooltipBody = hasPermission
    ? tooltipText
    : 'You do not have permission to perform this action'

  return (
    <Tooltip
      id={tooltipId}
      tooltipBody={tooltipBody}
      placement={TooltipPositions.top}
      disabled={isButtonDisabled && !isDisabled}
    >
      <IconButton
        variant={IconButtonVariant.icon}
        onClick={onClick}
        disabled={isButtonDisabled}
        aria-label={tooltipText}
        data-testid={testId}
      >
        <DownloadArrowSVG />
      </IconButton>
    </Tooltip>
  )
}
